/* eslint-disable import/prefer-default-export */
export const THEMES = {
        LIGHT: 'LIGHT',
        ONE_DARK: 'ONE_DARK',
        UNICORN: 'UNICORN'
};
